<template>
  <ScreenAdapter>
  <div id="main">
    <Header :p_search="true" :content="$route.query.keywords" />
    <Nav />
    <div class="eol-main-container">
      <div class="search-keywords">您搜索的关键词“{{ $route.query.keywords }}”，共有{{total}}条结果</div>
      <div class="search-content">
        <div class="item" v-for="(item,index) in listData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
        <div class="flex-hide"></div>
        <div class="flex-hide"></div>
        <div class="flex-hide"></div>
      </div>
      <a-pagination v-if="listData&&listData.length>0" :defaultPageSize="size" :default-current="1" :total="total" @change="onChange" />
    </div>
    <Footer />
  </div>
</ScreenAdapter>
</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../config/services'
import utils from '../../config/utils'
import { Message } from "ant-design-vue"
import ScreenAdapter from "@/components/ScreenAdapter.vue"

export default {
  data () {
    let that = this
    return {
      school_code: services.HZ_CODE,
      listData: [], // 弘扬劳动三精神
      keywords: that.$route.query.keywords,
      keyList: [
        { path: "culture", id: "106", name: "党性修养", course_ids: [107, 108, 109, 118] },
        { path: "value", id: "110", name: "价值引领", course_ids: [111, 112, 113] },
        { path: "feelings", id: "121", name: "家国情怀", course_ids: [193, 194] },
        { path: "profession", id: "136", name: "职业素养", course_ids: [137, 139, utils.hz_mdzjfxId] },
        { path: "feature", id: "195", name: "特色文化", course_ids: [200, 201, 202] },
        { path: "vita", id: "152", name: "生命教育", course_ids: [153, 154, 155, 156, utils.hz_shsmdjkId] },
      ],
      page: 1,
      total: 0,
      size: 16,
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  async mounted () {
    await this.getListData()
  },
  methods: {
    // 请求列表数据
    async getListData () {
      let that = this
      await services.getCourseList({ page: this.page, size: this.size, q: that.keywords, school_code: this.school_code }).then(res => {
        this.listData = res.data.items
        this.total = res.data.total
      })
    },
    async onChange (val) {
      this.page = val
      await this.getListData()
    },
    jumpDetail (item) {
      let that = this
      that.keyList.forEach(row => {
        if (item.category_name.indexOf(row.name) > -1) {
          return window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=${row.path}`, "_blank")
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 660px;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto 40px;
  .search-keywords {
    font-size: 16px;
    font-weight: bold;
    color: #b61e2a;
    word-break: break-all;
    padding: 18px 0 25px;
  }
  .search-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      width: 320px;
      height: 178px;
      margin-bottom: 24px;
      cursor: pointer;
    }
    .flex-hide {
      flex: 0 0 280px;
      visibility: hidden;
      display: block;
    }
  }
}

// ant-page 红色
::v-deep .ant-pagination-item-active {
  border-color: transparent;
  background: #b61e2a;
}
::v-deep .ant-pagination-item:hover {
  border-color: #b61e2a;
}
::v-deep .ant-pagination-item:hover a,
::v-deep .ant-pagination-item a {
  color: #666666;
}
::v-deep .ant-pagination-item-active a,
::v-deep .ant-pagination-item-active:hover a {
  color: #ffffff;
}
::v-deep .ant-pagination-prev:focus .ant-pagination-item-link,
::v-deep .ant-pagination-next:focus .ant-pagination-item-link,
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  border-color: #b61e2a;
}
::v-deep .ant-pagination-prev:focus .ant-pagination-item-link .anticon {
  color: #b61e2a;
}
::v-deep .ant-pagination-next:focus .ant-pagination-item-link .anticon {
  color: #b61e2a;
}
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link .anticon {
  color: #b61e2a;
}
::v-deep .ant-pagination-next:hover .ant-pagination-item-link .anticon {
  color: #b61e2a;
}
::v-deep .ant-pagination {
  text-align: center;
  margin-top: 8px;
}
</style>